import socketio from 'socket.io-client'

export default socketio(process.env.API_HOST)



// WEBPACK FOOTER //
// ./src/config/socket.js